// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MensagensProgramadas_CarregaScheduledMessagesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for carrega_scheduled_messages() /mensagens_programadas/carrega_scheduled_messages
 * Returns an array of scheduled messages for DataTables consumption.
 * Overrides getDados() to return the flat array directly (wire-shape preservation for DataTable).
 */
import type { MensagensProgramadas_ScheduledMessageRow } from './MensagensProgramadas_ScheduledMessageRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type MensagensProgramadas_CarregaScheduledMessagesResponseDados = MensagensProgramadas_ScheduledMessageRow[];

export type MensagensProgramadas_CarregaScheduledMessagesResponse = ApiResponse<MensagensProgramadas_CarregaScheduledMessagesResponseDados>;

registerResponseContract('MensagensProgramadas_CarregaScheduledMessagesResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      message_id:     { type: 'string',  required: true },
      recipient:      { type: 'string',  required: true },
      content:        { type: 'string',  required: true },
      scheduled_time: { type: 'string',  required: true },
      status:         { type: 'string',  required: true },
      created_at:     { type: 'string',  required: true },
      meta:           { type: 'string',  required: true },
    },
  },
})
